import React, { createContext, useContext } from 'react';
import { useOrganizationService, OrgMembership, OrgRole } from '@/hooks/useOrganizationService';

interface OrganizationContextValue {
  loading: boolean;
  organizations: OrgMembership[];
  activeOrg: OrgMembership | null;
  setActiveOrg: (orgId: string) => void;
  hasRole: (minRole: OrgRole) => boolean;
  refresh: () => Promise<void>;
}

const OrganizationContext = createContext<OrganizationContextValue | undefined>(undefined);

export function OrganizationProvider({ children }: { children: React.ReactNode }) {
  const value = useOrganizationService();
  return <OrganizationContext.Provider value={value}>{children}</OrganizationContext.Provider>;
}

export function useOrganization() {
  const context = useContext(OrganizationContext);
  if (context === undefined) {
    throw new Error('useOrganization must be used within an OrganizationProvider');
  }
  return context;
}
